import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { Parameter } from "../models/Parameter";
import { ClientQuotationDTO } from "../models/Quotation/ClientQuotationDTO";
import { CreateClientQuotationDTO } from "../models/Quotation/CreateClientQuotationDTO";
import { RequestChangesClientQuotationDTO } from "../models/Quotation/ReviewChangesClientQuotationDTO";
import { APIService } from "./APIService";
import axios, { AxiosError } from 'axios';
import { StatusDTO } from "../models/Status/StatusDTO";
import { UpdateClientQuotationDTO } from "../models/Quotation/UpdateClientQuotationDTO";
import { ApproveClientQuotationDTO } from "../models/Quotation/ApproveClientQuotationDTO";
import { UpdateClientQuotationAssistanceDTO } from "../models/Quotation/UpdateClientQuotationAssistanceDTO";

export class ClientQuotationService {
    async Create(data: CreateClientQuotationDTO): Promise<MessagingHelper<number>> {
        try {
          var response = await APIService.Axios().post(
            `${APIService.GetURL()}/ClientQuotation/Create`,
            {
              ...data,
            },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + APIService.GetToken(),
              },
            }
          );
          return response.data;
        } catch (error) {
          return new MessagingHelper<number>(
            false,
            "Erro ao ligar ao servidor para criar a proposta",
            0
          );
        }
      }

      async GetAll(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<ClientQuotationDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/ClientQuotation/GetAll`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<ClientQuotationDTO>(
                false,
                "Erro ao ligar ao servidor ao obter a informação das propostas",
                "",
                [],
                0,
            );
        }
    }
    async GetAllStatus(): Promise<MessagingHelper<StatusDTO[]>> {
      try {
          const response = await APIService.Axios().get(
              `${APIService.GetURL()}/ClientQuotation/GetAllStatus`,
              {
                  headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + APIService.GetToken(),
                  },
              }
          );
          return response.data;
      } catch (error) {
          console.error(error);
          return new MessagingHelper<StatusDTO[]>(
              false,
              "Erro ao ligar ao servidor para obter os status das propostas",
              []
          );
      }
  }
    async GetById(id: number, token?:string): Promise<MessagingHelper<ClientQuotationDTO | null>> {
      try {
        const url = token
        ?  `${APIService.GetURL()}/ClientQuotation/public/${id}?token=${token}`
        : `${APIService.GetURL()}/ClientQuotation/${id}`;
       const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(token ? {} : { Authorization: `Bearer ${APIService.GetToken()}` }),
    };

    const response = await APIService.Axios().get(url, { headers });

          return response.data;
      } catch (error) {
          return new MessagingHelper<null>(
              false,
              "Erro ao ligar ao servidor ao obter a informação da proposta",
              null
          );
      }
    }

    async AcceptClientQuotation(id:number, request: RequestChangesClientQuotationDTO, token: string): Promise<MessagingHelper<ClientQuotationDTO | null>> {
      try {
        var response = await APIService.Axios().post(
          `${APIService.GetURL()}/ClientQuotation/AcceptClientQuotation/${id}?token=${token}`,
            request,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        return response.data;
      } catch (error) {
        return new MessagingHelper<ClientQuotationDTO | null>(
          false,
          "Erro ao ligar ao servidor para registar a decisão da proposta",
          null
        );
      }
    }
    async RejectClientQuotation(id:number, request: RequestChangesClientQuotationDTO, token: string): Promise<MessagingHelper<ClientQuotationDTO | null>> {
      try {
        var response = await APIService.Axios().post(
          `${APIService.GetURL()}/ClientQuotation/RejectClientQuotation/${id}?token=${token}`,
            request,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        return response.data;
      } catch (error) {
        return new MessagingHelper<ClientQuotationDTO | null>(
          false,
          "Erro ao ligar ao servidor para registar a decisão da proposta",
          null
        );
      }
    }
    async RequestChanges(id:number, request: RequestChangesClientQuotationDTO, token: string): Promise<MessagingHelper<ClientQuotationDTO | null>> {
      try {
        var response = await APIService.Axios().post(
          `${APIService.GetURL()}/ClientQuotation/RequestChanges/${id}?token=${token}`,
            request,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        return response.data;
      } catch (error) {
        return new MessagingHelper<ClientQuotationDTO | null>(
          false,
          "Erro ao ligar ao servidor para registar a decisão da proposta",
          null
        );
      }
    }
    async Update(data: UpdateClientQuotationDTO, id: number): Promise<MessagingHelper<number>> {
      try {

          data.partsAndServicesQuotationDTO?.forEach(item => {
              item.quantity = Number(item.quantity); 
              item.partId = String(item.partId);    
          });
  
          console.log("Dados enviados para o servidor:", JSON.stringify(data));
  
          const response = await APIService.Axios().post(
              `${APIService.GetURL()}/ClientQuotation/UpdatePartsAndServices/${id}`,
              data,
              {
                  headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + APIService.GetToken(),
                  },
              }
          );
          return response.data;
      } catch (error) {
          return new MessagingHelper<number>(
              false,
              "Erro ao ligar ao servidor para atualizar a proposta",
              0
          );
      }
  }
  
  
    async TecnicianUpdateStatus(id: number, dto: ApproveClientQuotationDTO): Promise<MessagingHelper<ClientQuotationDTO | null>> {
      try {
        var response = await APIService.Axios().post(
          `${APIService.GetURL()}/ClientQuotation/TecnicianUpdateStatus/${id}`,
          dto,  // Envia a dto com a informação pretendida
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + APIService.GetToken(),
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error(error);
        return new MessagingHelper<ClientQuotationDTO | null>(
          false,
          "Erro ao ligar ao servidor para registar a decisão da proposta",
          null
        );
      }
    }
    async SendEmail(id: number): Promise<MessagingHelper<number>> {
    try{
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/ClientQuotation/SendEmail/${id}`,
        {},
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    }catch (error) {
      console.error(error);
      return new MessagingHelper<number>(
        false,
        "Erro ao ligar ao servidor para enviar proposta ao cliente",
        0
      );
    }
    }
    async softDeleteClientQuotation(id: number): Promise<MessagingHelper<number>> {
      try{
        var response = await APIService.Axios().delete(
          `${APIService.GetURL()}/ClientQuotation/${id}`,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + APIService.GetToken(),
            },
          }
        );
        return response.data;
      }catch (error) {
        console.error(error);
        return new MessagingHelper<number>(
          false,
          "Erro ao ligar ao servidor para apagar proposta do cliente",
          0
        );
      }
  }
  async Cancel(id: number): Promise<MessagingHelper<number>> {
    try{
      var response = await APIService.Axios().put(
        `${APIService.GetURL()}/ClientQuotation/Cancel/${id}`,
        null,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    }catch (error) {
      console.error(error);
      return new MessagingHelper<number>(
        false,
        "Erro ao ligar ao servidor para cancelar proposta do cliente",
        0
      );
    }
}
   async SendPartsToAssistance(id: number): Promise<MessagingHelper<number>> {
    try{
      var response = await APIService.Axios().post(
        `${APIService.GetURL()}/ClientQuotation/SendPartsToAssistance/${id}`,
        {},
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + APIService.GetToken(),
          },
        }
      );
      return response.data;
    }catch (error) {
      console.error(error);
      return new MessagingHelper<number>(
        false,
        "Erro ao ligar ao servidor para enviar partes da proposta para a assistência",
        0
      );
    }
    }
    async UpdateAssistance(data: UpdateClientQuotationAssistanceDTO, id: number): Promise<MessagingHelper<number>> {
      try {  
          const response = await APIService.Axios().post(
              `${APIService.GetURL()}/ClientQuotation/UpdateAssistance/${id}`,
              data,
              {
                  headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + APIService.GetToken(),
                  },
              }
          );
          return response.data;
      } catch (error) {
          return new MessagingHelper<number>(
              false,
              "Erro ao ligar ao servidor para atualizar a proposta",
              0
          );
      }
  }
}
